export enum AuthUserPerfilId {
  PertencerChat = 'assembleias_pertencer_chat',
  PertencerAdmin = 'pertencer_admin',
  PertencerConsulta = 'pertencer_consulta',
  PertencerGestao = 'pertencer_gestao',
  Associado = 'ASSOCIADO',
  AssociadoConvidado = 'CONVIDADO',
  Deslogado = 'deslogado',
  Representante = 'REP_PF',
}

export interface IAuthUserPerfil {
  id: AuthUserPerfilId;
  nome: string;
  associadoRoute: {
    assembleias: {
      pre: {
        ver: boolean;
        videos: {
          ver: boolean;
          participar: boolean;
        };
        documentos: {
          ver: boolean;
          participar: boolean;
        };
        duvidasSugestoes: {
          ver: boolean;
          participar: boolean;
        };
      };
      live: {
        ver: boolean;
        video: {
          ver: boolean;
          participar: boolean;
        };
        documentos: {
          ver: boolean;
          participar: boolean;
        };
        duvidasSugestoes: {
          ver: boolean;
          participar: boolean;
        };
      };
      pautas: {
        ver: boolean;
        participar: boolean;
      };
    };
  };
  assessorRoute: {
    assembleias: {
      ver: boolean;
      excluir: boolean;
      alterarSituacao: boolean;
      documentos: {
        ver: boolean;
        editar: boolean;
      };
      participantes: {
        verTotal: boolean;
        confirmar: boolean;
      };
      pautas: {
        ver: boolean;
        alterarSituacao: boolean;
        incluirVotoManual: boolean;
        editar: boolean;
        deletar: boolean;
        anexos: {
          ver: boolean;
        };
      };
      cadastroPauta: {
        cadastrar: boolean;
      };
      relatorio: {
        votacao: boolean;
        evento: boolean;
      };
      videos: {
        editar: boolean;
      };
      adicionarConvidado: boolean;
    };
    duvidasSugestoes: {
      ver: boolean;
      responder: boolean;
      alterarSituacao: boolean;
      incluirMensagem: boolean;
      mensagemAssessor: boolean;
      relatorio: boolean;
    };
    parametros: {
      ver: boolean;
      editar: boolean;
    };
    quorum: {
      ver: boolean;
      alterarRepresentante: boolean;
    };
    logins: {
      ver: boolean;
    };
    cadastros: {
      ver: boolean;
    };
    notificacoes: {
      ver: boolean;
    };
  };
}
